<div class="instruments-section">
  @if (instrumentViews().length > 0) {
    <ul class="instruments-section__list">
      @for (view of instrumentViews(); track view.instrument.appFunctionId) {
        <li class="instruments-section__item" [matTooltip]="view.title ?? ''" matTooltipClass="card-tooltip">
          {{
            view.title ?? ('epd.functions.careplan-nnn.instruments-section.unknown-instrument' | translate | capitalize)
          }}
        </li>
      }
    </ul>
  }
  @if (editable()) {
    <button mat-button color="primary" class="instruments-section__edit" (click)="openEdit()">
      <mat-icon>edit</mat-icon>
      {{ 'epd.functions.careplan-nnn.instruments-section.select' | translate | capitalize }}
    </button>
    <div class="instruments-section__save-state">
      @if (saveState() === 'saving') {
        <span>{{ 'general.actions.saving' | translate }}</span>
      } @else if (saveState() === 'saved') {
        <span class="instruments-section__save-state--saved">{{ 'general.words.saved' | translate }}</span>
      }
    </div>
  }
</div>
